export const SearchFilterLength = {
    RECENT: 2,
    GROUPED: 3,
};
export const SearchFilter = {
    LIMIT: 25
};
export const NO_MESSAGES_YET = "No messages yet";
export const NO_MESSAGES_YET_WORDS = NO_MESSAGES_YET.toLowerCase().split(" ");
export const DELETE_MESSAGES_TEXT = "This message was deleted.";
export const YOU_DELETE_MESSAGES_TEXT = "You: Message has been deleted";
export const MESSAGES_WAS_DELETED = "Message deleted";

export const TOAST_ERROR_CREATING_CHANNEL = "Error creating channel!";
export const TOAST_CHANNEL_NOT_FOUND = "Channel not found.";
export const TOAST_CONVERSATION_DELETED = "Conversation deleted.";
export const TOAST_FAILED_TO_DELETE_CONVERSATION = "Failed to delete conversation.";
export const TOAST_MESSAGE_DELETED = "Message deleted.";
export const TOAST_FAILED_TO_DELETE_MESSAGE = "Failed to delete message.";
export const TOAST_FAILED_TO_BLOCK_USER="Failed to block user.";
export const TOAST_APPOINTMENT_CANCELED = "This appointment has been canceled.";
export const TOAST_APPOINTMENT_ACCEPTED = "Your appointment has been accepted.";
export const TOAST_APPOINTMENT_REJECTED = "Your appointment has been declined.";
export const BLOCK_USER_TITLE = "Block the User";
export const BLOCK_USER_MESSAGE = "You will not be able to chat with the user again.";
export const DELETE_USER_MESSAGE_TITLE = "Delete Message";
export const DELETE_USER_SINGLE_MESSAGE = "This message will be deleted from your device.";
export const EDIT_USER_MESSAGE_TITLE = "Edit Message";
export const INIT_APPLICATION_MESSAGE="Initializing application, please wait.";

